import { z } from 'zod';

import { optionalString, requiredString } from '@/shared/utils/validation';

export const sewBillingCycleExportValidationInputSchema = (
  requireRegion = false,
) =>
  z.object({
    billingCycleReferenceTs: requiredString(),
    region: requireRegion ? requiredString() : optionalString(),
  });
